import { IAzureAuthentication } from "./interfaces/iazureauthentication";
import { IUser } from "./interfaces/ilogin";
import { IErrorStatus } from "./interfaces/ierrorstatus";
import { ActionReducerMap } from "@ngrx/store";
import { ILoading } from "./reducers/loading.reducer";
import * as azureAuthentication from "./reducers/azureauthentication.reducer";
import * as applicationUser from "./reducers/applicationuser.reducer";
import * as loading from "./reducers/loading.reducer";
import * as errorStatus from "./reducers/errorstatus.reducer";

export interface IAppStore {
    azureAuthentication: IAzureAuthentication;
    user: IUser;
    loading: ILoading;
    errorStatus: IErrorStatus;
}

export const reducers: ActionReducerMap<IAppStore> = {
    azureAuthentication: azureAuthentication.azureAuthenticationReducer,
    user: applicationUser.applicationUserReducer,
    loading: loading.loadingReducer,
    errorStatus: errorStatus.errorStatusReducer
};